module.exports = __webpack_public_path__ + "static/media/classic21.6170936d.png";